import React from 'react'
import { SimpleGrid, Stack, Title } from '@mantine/core'
import { Car, Star } from 'lucide-react'
import StatisticCard from '../../../components/StatisticCard'
import EvolutionChart from '../../../components/EvolutionChart'

type AdminDashboardIndexProps = {
  reviews_count: number
  vehicles_count: number
  mean_note: number
  reviews_graph_data: { label: string; date: string; count: number }[]
  reviews_monthly_graph_data: { label: string; date: string; count: number }[]
}

const AdminDashboardIndex: React.FC<AdminDashboardIndexProps> = (props) => {
  const { reviews_count, vehicles_count, mean_note, reviews_graph_data, reviews_monthly_graph_data } = props

  return (
    <Stack gap="xl">
      <Title order={2}>Dashboard</Title>
      <SimpleGrid cols={{ base: 1, sm: 2, md: 4 }}>
        <StatisticCard
          title="Nombre d'avis"
          value={reviews_count.toLocaleString()}
          icon={Star}
        />
        <StatisticCard
          title="Nombre de véhicules"
          value={vehicles_count.toLocaleString()}
          icon={Car}
        />
        <StatisticCard
          title="Note moyenne"
          value={mean_note.toLocaleString()}
          icon={Star}
        />
      </SimpleGrid>

      <SimpleGrid cols={{ base: 1, md: 2 }}>
        <EvolutionChart
          title="Évolution des avis (12 dernières semaines)"
          data={reviews_graph_data}
          lineColor="#5B42FA"
        />
        <EvolutionChart
          title="Évolution des avis (6 derniers mois)"
          data={reviews_monthly_graph_data}
          lineColor="#10b981"
        />
      </SimpleGrid>
    </Stack>
  )
}

export default AdminDashboardIndex
